import * as React from 'react';

function SvgToolbox(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 54 55" {...props}>
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 32.376h50.501V52.15a1.5 1.5 0 0 1-1.5 1.5H2.5a1.5 1.5 0 0 1-1.5-1.5zM37.072 38.94H15.43M51.501 38.94h-8.06M9.059 38.94H1M39.67 32.376a8.05 8.05 0 0 1-.742-3.34q0-.24.016-.48l-3.423-.597c-.483 1.752-1.601 3.296-3.196 4.41"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m35.523 27.96 3.323-19.413-.21-3.179L40.753 1l2.227.39.54 4.833-1.254 2.922-3.32 19.414M28.09 32.344l3.78-14.493-5.294-1.38-3.781 14.494.454 1.346M43.405 32.376l1.282-7.674 4.008.67-1.172 7.004M48.057 25.145l.294-1.763 1.726-1.378 2.56-15.333-6.643 5.303-1.52 9.093 1.155 1.85-.295 1.763M20.04 32.376l-1.445-18.517M14.97 32.376l-1.412-18.127M21.816 6.994c.221-.454.671-.78 1.212-.822l1.575-.121a.723.723 0 0 1 .777.664l.357 4.561a.723.723 0 0 1-.665.778l-1.575.121a1.48 1.48 0 0 1-1.24-.516M19.195 13.79l-6.189.483a6.4 6.4 0 0 0-.68-1.794c-1.13-2.01-3.008-2.18-5.314-2.17l-5.343.148 3.62-2.098c1.913-1.11 4.042-1.817 6.244-1.996.016 0 7.007-.547 7.007-.547l1.1 1.344 2.165-.168.372 4.758-.63.197c-1.051.328-1.902.997-2.352 1.843M4.23 24.837l-.623-4.61 4.77-3.945 1.06 7.851M3.718 32.285l-.802-6.12a.893.893 0 0 1 .769-1.002l6.404-.84a.893.893 0 0 1 1 .77l.982 7.216"
    />
  </svg>)
}
export default SvgToolbox;
